// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__gSA_U","title":"Info_title__3oU05","links":"Info_links__3ORaN","link":"Info_link__hKl1g","logo":"Info_logo__1mIrP"};